<template>
  <notification
    @notification-click="$emit('notification-click', $event)"
    type="award"
    :notification="formattedNotification"
  >
    <template slot="context-content" v-if="showPreview">
      <award-widget :award="notification.data.award" show-note-as="plain" :clamp-note="true" />
    </template>
  </notification>
</template>

<script>
import { AWARD_TYPE } from '@/constants/awards'
import * as R from 'ramda'
import Notification from '@/components/notifications/Notification'
import AwardWidget from '@/components/award/AwardWidget'

/**
 * This is the component for rendering a award's notification
 */
export default {
  name: 'AwardNotification',
  props: {
    notification: Object,
    showPreview: Boolean
  },
  components: {
    Notification,
    AwardWidget
  },
  computed: {
    context() {
      return R.path(['data', 'award', 'context'], this.notification)
    },
    isCheckinAward() {
      return R.pathEq(['data', 'award', 'type'], AWARD_TYPE.CHECKIN, this.notification)
    },
    onKr() {
      return this.isCheckinAward || this.notification.data.award.type === AWARD_TYPE.KEY_RESULT
    },
    formattedNotification() {
      const data = this.notification.data
      const notification = {
        ...this.notification,
        data: {
          ...data,
          event: {
            id: data.awardEventId
          }
        }
      }
      if (this.isCheckinAward) {
        const keyResult = this.context.keyResult
        notification.data.keyResult = keyResult
      } else if (this.onKr) {
        notification.data.keyResult = {
          title: this.context.title,
          id: this.context.id,
          goalId: this.context.goalId
        }
      }
      return notification
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .comment {
  padding-left: 20px;
}
/deep/ .kr-value {
  font-size: 0.8125rem;
}
/deep/ .status-label {
  font-size: 0.8125rem;
}
</style>
